__turbopack_context__.v({
  "active": "Button-module-scss-module__MGDXUG__active",
  "black": "Button-module-scss-module__MGDXUG__black",
  "button": "Button-module-scss-module__MGDXUG__button",
  "close": "Button-module-scss-module__MGDXUG__close",
  "closeInverse": "Button-module-scss-module__MGDXUG__closeInverse",
  "danger": "Button-module-scss-module__MGDXUG__danger",
  "gold": "Button-module-scss-module__MGDXUG__gold",
  "header": "Button-module-scss-module__MGDXUG__header",
  "isNative": "Button-module-scss-module__MGDXUG__isNative",
  "primary": "Button-module-scss-module__MGDXUG__primary",
  "secondary": "Button-module-scss-module__MGDXUG__secondary",
  "secondaryDarkGrey": "Button-module-scss-module__MGDXUG__secondaryDarkGrey",
  "secondaryGrey": "Button-module-scss-module__MGDXUG__secondaryGrey",
  "secondaryOutline": "Button-module-scss-module__MGDXUG__secondaryOutline",
  "secondaryWhite": "Button-module-scss-module__MGDXUG__secondaryWhite",
  "success": "Button-module-scss-module__MGDXUG__success",
  "text": "Button-module-scss-module__MGDXUG__text",
  "textMuted": "Button-module-scss-module__MGDXUG__textMuted",
  "waiting": "Button-module-scss-module__MGDXUG__waiting",
  "wrapper": "Button-module-scss-module__MGDXUG__wrapper",
});
